module.exports = __webpack_public_path__ + "static/media/project5.7977619a.png";